import { dictionary } from "@/schemas/dictionary";
import { z } from "@/zod";

const storeFormat = dictionary.extend({
  description: z.string().max(250).optional(),
});

export const readStoreFormat = storeFormat.readonly();
export const writeStoreFormat = storeFormat.omit({
  id: true,
});
